import { IdTokenResult } from 'firebase/auth';

export enum Role {
    Admin = 'admin',
    Dev = 'dev',
    OrgAdmin = 'orgAdmin',
    OrgUser = 'orgUser',
    OrgFinance = 'orgFinance',
}

export function isRole(value: string): value is Role {
    return Object.values(Role).includes(value as Role);
}

export type EditableRole = Exclude<Role, Role.Admin | Role.Dev>;

export function isEditableRole(value: string): value is EditableRole {
    return Object.values(Role).includes(value as Role) && value !== Role.Admin && value !== Role.Dev;
}

export function isOrgAdmin(result: IdTokenResult): boolean {
    const roles = result.claims.roles;

    return Array.isArray(roles) && roles.includes(Role.OrgAdmin);
}
